import { Text } from "@fluentui/react-components";
import { Edit24Regular, FormNew24Regular } from "@fluentui/react-icons";

import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useDevicesContext } from "../context/DevicesContext";
import { useDeviceDrawerStore } from "../store/DeviceDrawerStore";

import { useDeleteDeviceMutation } from "../api/Delete";

import BaseDrawer from "../../../components/BaseDrawer";
import DeviceForm from "./DeviceForm";
import OverlaySpinner from "../../../components/OverlaySpinner";

export default function DeviceDrawer() {
    const { isOpen, isEdit, close, data } = useDeviceDrawerStore();

    const { showDialog, showNotification } = useUtilitiesContext();
    const { refetchDevices } = useDevicesContext();

    const deleteMutation = useDeleteDeviceMutation(
        () => {
            showNotification({
                type: "success",
                title: "Deleted",
                message: <Text>The device <b>{data?.label}</b> is pending approval for deletion.</Text>,
                
            });
            refetchDevices();
            close();
        },
        (error: Error) => {
            showNotification({
                type: "error",
                title: "Error",
                message: error.message,
            });
        }
    );
    const handleDelete = () => {
        if (data) {
            showDialog({
                title: "Delete device",
                content: <Text>Are you sure you want to delete device <b>{data.label}</b> ?</Text>,
                primaryActionText: "Yes",
                primaryAction: () => deleteMutation.mutate(data.id),
                secondaryActionText: "No",
                secondaryAction: () => { },
            });
        }
    };

    const drawerTitle = isEdit ? "Edit device" : "New device";
    const drawerIcon = isEdit ? <Edit24Regular /> : <FormNew24Regular />;

    return (
        <BaseDrawer
            title={drawerTitle}
            icon={drawerIcon}
            size="small"
            isOpen={isOpen}
            close={close}
            removable={isEdit}
            remove={handleDelete}
        >
            <OverlaySpinner open={deleteMutation.isPending} label="Deleting..." />
            <DeviceForm />
        </BaseDrawer>
    )
}